import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule, LazyImport, createLazyComponent, type LazyComponent, } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "SearchRefiners"*/ "./lazyIndex"), { name: "SearchRefiners" });

// Lazy-load components
export const RefinersContainer: LazyComponent<RefinersContainerProps, unknown, void> = createLazyComponent(lazyModule, m => m.RefinersContainer, undefined, undefined, {
    govern: true,
});

export const lazySetRefinersInstrumentationContext: LazyImport<typeof lazyIndex.setRefinersInstrumentationContext, typeof lazyModule> = new LazyImport(lazyModule, m => m.setRefinersInstrumentationContext);

export const lazyLogInitialRefinersInstrumentation: LazyImport<typeof lazyIndex.logInitialRefinersInstrumentation, typeof lazyModule> = new LazyImport(lazyModule, m => m.logInitialRefinersInstrumentation);

// Register mutators
import "./mutators/initializeRefinersScenarioStore";
import type { RefinersContainerProps } from "./components/RefinersContainer";

// selectors
export { default as getAppliedRefiners } from "./selectors/getAppliedRefiners";
export { default as getSuggestedRefiners } from "./selectors/getSuggestedRefiners";
export { default as getSearchRefinersState } from "./selectors/getSearchRefinersState";

// actions
export const lazyClearAppliedRefiners: LazyAction<typeof lazyIndex.clearAppliedRefiners, typeof lazyModule> = new LazyAction(lazyModule, m => m.clearAppliedRefiners);
export const lazySetSuggestedRefiners: LazyAction<typeof lazyIndex.setSuggestedRefiners, typeof lazyModule> = new LazyAction(lazyModule, m => m.setSuggestedRefiners);
export const lazyClearSuggestedRefiners: LazyAction<typeof lazyIndex.clearSuggestedRefiners, typeof lazyModule> = new LazyAction(lazyModule, m => m.clearSuggestedRefiners);
export const lazyApplyBooleanRefiner: LazyImport<typeof lazyIndex.applyBooleanRefiner, typeof lazyModule> = new LazyImport(lazyModule, m => m.applyBooleanRefiner);
export const lazyRemoveRefiner: LazyImport<typeof lazyIndex.removeRefiner, typeof lazyModule> = new LazyImport(lazyModule, m => m.removeRefiner);
